import { KText } from '@/ui-library/components/text';

export interface MaxLengthCounterProps {
  currentLength: number;
  maxLength: number;
  disabled?: boolean;
  showError?: boolean;
}

/**
 * `<current>/<max>` indicator for length-capped fields.
 *
 * Inputs and textareas both cap typing/pasting via the native `maxLength`
 * attribute, which truncates silently — without this counter the user has no
 * way to tell why their text stopped (CORE-5052 / ENG-3553).
 *
 * Positioning is the caller's job: `InputField` renders it inline inside the
 * `InputGroup`, `TextareaField` renders it right-aligned under the textarea.
 */
export function MaxLengthCounter({
  currentLength,
  maxLength,
  disabled,
  showError,
}: MaxLengthCounterProps) {
  return (
    <KText
      size="xs-medium"
      pr="5px"
      background={'transparent'}
      borderTopRightRadius="6px"
      borderBottomRightRadius="6px"
      color={
        disabled ? 'secondary-300' : showError ? 'error-200' : 'secondary-700'
      }
    >
      {currentLength}/{maxLength}
    </KText>
  );
}
